<template>
  <transition name="red">
    <div :class="[backgroundStyle]">
      <div :class="[LoginStyle]">
        <div class="login-nav">
          <login-nav @loginWay="loginWay" />
        </div>
        <div class="login-box">
          <login-box
            :ispassyzm="ispassyzm"
            :loginway="loginWayToBox"
            @rememberPwd="rememberPwd"
            @login="login"
            @getYZM="getYZM"
            @countDown="countDown"
          />
        </div>
        <img src="../../../static/images/returnbutton.png" alt="返回按钮" class="return-button" style="cursor:pointer" @click="closeLogin">
      </div>
    </div>
  </transition>
</template>
<script>
import LoginBox from './LoginBox'
import LoginNav from './LoginNav'
export default {
  components: {
    'login-box': LoginBox,
    'login-nav': LoginNav
  },
  props: {
    ispassyzm: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      direction: 'red',
      backgroundStyle: 'red',
      LoginStyle: 'login-banner-red',
      loginWayToBox: 1,
      loginway: 1 // 选择登录的系统 1为终端 2为商业 3为后台
    }
  },
  methods: {
    login (name, password, isYZMLogin) {
      this.$emit('login', name, password, isYZMLogin, this.loginway)
    },
    rememberPwd (isRemember) {
      this.$emit('rememberPwd', isRemember)
    },
    getYZM (phone) {
      this.$emit('getYZM', phone)
    },
    countDown () {
      this.$emit('countDown')
    },
    closeLogin () {
      this.$emit('closeLogin')
    },
    loginWay (loginWay) {
      switch (loginWay) {
        case 1:
          this.LoginStyle = 'login-banner-red'
          this.backgroundStyle = 'red'
          this.loginway = 1
          this.loginWayToBox = 1
          break
        case 2:
          this.LoginStyle = 'login-banner-yellow'
          this.backgroundStyle = 'yellow'
          this.loginway = 2
          this.loginWayToBox = 2
          break
        case 3:
          this.LoginStyle = 'login-banner-blue'
          this.backgroundStyle = 'blue'
          this.loginway = 3
          this.loginWayToBox = 3
          break
      }
    }
  }
}
</script>
<style scoped>

.return-button{
 position: relative;
  width: 40px;
  height: 40px;
}
  .login-banner-yellow{
    margin: 0 auto;
    display: flex;
    justify-content:space-between;
    width: 1200px;
    height: 100%;
    background-image: url("../../../static/images/loginyellow.jpg")

  }
  .login-banner-blue{
     margin: 0 auto;
    display: flex;
    justify-content:space-between;
    width: 1200px;
    height: 100%;
    background-image: url("../../../static/images/loginblue.jpg")
  }
  .login-banner-red{
    margin: 0 auto;
    display: flex;
    justify-content:space-between;
    width: 1200px;
    height: 100%;
    background-image: url("../../../static/images/loginred.jpg")
  }
  .red{
    height: 630px;
    width: 100%;
    background-color: #e62129;
  }
  .blue{
    height: 630px;
     width: 100%;
    background-color: #009be7
  }
  .yellow{
    height: 630px;
    width: 100%;
    background-color:#fea31f
  }
  .login-nav{
    margin-left: 0px;
    width: 53px;
    height: 100%;
  }
  .login-box{
    margin-top: 73px;
    margin-right: -720px;
    width: 400px;
    height: 450px;
  }
</style>
